import LandOperatorPage from './LandOperatorPage.container'
export default LandOperatorPage
